import { useMutation, useQueryClient } from '@tanstack/react-query';
import { overrideVettingApplicationDecision } from '../services/vettingApplications';
import { vettingApplicationQueryKeys } from './query-keys';

export const useOverrideVettingDecisionMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ applicationId, decision, reason }) => {
      const result = await overrideVettingApplicationDecision(applicationId, {
        decision,
        reason,
      });
      if (!result.success) {
        throw new Error(result.message || 'Failed to override decision');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: vettingApplicationQueryKeys.all });
      await queryClient.invalidateQueries({
        queryKey: vettingApplicationQueryKeys.detail(variables?.applicationId),
      });
      await onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};
